export const riskCategoriesMap: any = {
  $DECODE_CH: "Uncovering the hidden harms of high cholesterol",
  $UNMASK_CH_THREATS: "Understanding high cholesterol and its risks",
  $STATIN_MYTHS:
    "Taking Statin medicines: dispelling common myths and misconceptions",
  $STATIN_BARRIERS: "Integrating statin into my life and daily routines",
  $RISK_UNKNOWN: "Unknown Risk",
};
